import { render, staticRenderFns } from "./UpdateStaffDialog.vue?vue&type=template&id=54b90597"
import script from "./UpdateStaffDialog.vue?vue&type=script&lang=js"
export * from "./UpdateStaffDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports